export const snakeToCamel = (str: string) => {
  const result = str.replace(/([-_][a-zA-Z0-9])/g, group => {
    return group
      .toUpperCase()
      .replace('-', '')
      .replace('_', '');
  });
  return result;
};
